import React from 'react'
import { StatusGood, StatusBad, StatusWarning, StatusCritical, ToolTipBulb, AwardButton, SupervisorButton, RunningButton, CryButton, NoShowButton, ApptCompleteButton, RescheduledButton, CheckedInButton, RTMButton } from '_components';
import { store } from '_helpers'
import { getDateMDYY } from './utils';
import { faPeopleArrows } from '@fortawesome/free-solid-svg-icons';

export function codeValidForAdmit(epno, code) {
    let state = store.getState();

    return Object.keys(state.entities.trtCodes)
        .filter(x => state.entities.trtCodes[x].epno === epno && state.entities.trtCodes[x].code.trim() === code.trim()).length > 0 ? true : false;
}

export function codeTimed(code) {
    let codeInt = parseInt(code);

    if (!isNaN(codeInt)) { // integer value
        if (
            (codeInt >= 97032
                && codeInt <= 97542
                && codeInt !== 97150
                && codeInt !== 97161
                && codeInt !== 97162
                && codeInt !== 97163
                && codeInt !== 97164
                && codeInt !== 97165
                && codeInt !== 97166
                && codeInt !== 97167
                && codeInt !== 97168
            )
            || codeInt === 97760
            || codeInt === 97761
            || codeInt === 97762
            || codeInt === 97750
        ) {
            return true;
        }
    }
    return false;
}


export function getStatusIndicator(status) {
    switch (status) {
        case 1:
            return (<StatusGood size='extra-small' />);
        case 2:
            return (<StatusWarning size='extra-small' />);
        case 3:
            return (<StatusCritical size='extra-small' />);
        case 4:
            return (<StatusCritical size='extra-small' />);
        default:
            return (<span />);
    }
}

export function getIconStatusIndicator(status) {
    switch (status) {
        case 1:
            return (<StatusGood size='smaller' backgroundColor='white' color='green' />);
        case 2:
            return (<StatusWarning size='smaller' />);
        case 3:
            return (<StatusBad size='smaller' />);
        case 4:
            return (<StatusCritical size='smaller' />);
        default:
            return (<span />);
    }
}

export function getRTMStatusIndicator(status) {
    switch (status) {
        case 1:
            return (<RTMButton size='smaller' color="greenText" title="Enabled and activated" />);
        case 2:
            return (<RTMButton size='smaller' color="yellowText" title="Enabled but not activated" />);
        case 3:
            return (<RTMButton size='smaller' color="redText" title="Not enabled and not activated" />);
        case 4:
            return (<RTMButton size='smaller' color="redText" title="Not enabled and not activated" />);
        default:
            return (<span />);
    }
}

export function getPocTextLong(poc) {
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    var txt = '(';
    poc.visitMin !== 0 ? txt += poc.visitMin : txt += '';
    poc.visitMin !== 0 && poc.visitMax !== 0 ? txt += '-' : txt += '';
    poc.visitMax !== 0 ? txt += poc.visitMax : txt += '';
    txt += ' time';
    poc.visitMax !== 0 && poc.visitMax !== 1 ? txt += 's' : txt += '';
    txt += ' per ';
    txt += poc.visitLabel;
    txt += ' x ';
    poc.durationMin !== 0 ? txt += poc.durationMin : txt += '';
    poc.durationMin !== 0 && poc.durationMax !== 0 ? txt += '-' : txt += '';
    poc.durationMax !== 0 ? txt += poc.durationMax : txt += '';
    txt += ' ' + poc.durationLabel + ';';
    txt += ' visit ';
    txt += poc.actualVisits;
    txt += ' of ';
    txt += poc.pocVisits;
    if (new Date(poc.endDate).getTime() < today.getTime()) {
        txt += '; expired ';
    } else {
        txt += '; expires ';
    }
    txt += getDateMDYY(poc.endDate);
    txt += ')'
    return txt;
}

export function getPocText(poc) {
    var txt = '';
    poc.visitMin !== 0 ? txt += poc.visitMin : txt += '';
    poc.visitMin !== 0 && poc.visitMax !== 0 ? txt += '-' : txt += '';
    poc.visitMax !== 0 ? txt += poc.visitMax : txt += '';
    txt += ' x ';
    poc.durationMin !== 0 ? txt += poc.durationMin : txt += '';
    poc.durationMin !== 0 && poc.durationMax !== 0 ? txt += '-' : txt += '';
    poc.durationMax !== 0 ? txt += poc.durationMax : txt += '';
    txt += ' ' + poc.durationLabel;
    return txt;
}


export function getGoalSentenceFunc(activityName, goalLevelSentence, goal, loa) {
    let sentence = 'Patient will be able to ';
    if (activityName !== '') {
        sentence += activityName;
    } else {
        sentence += '[Activity]'
    }
    if (goalLevelSentence !== '') {
        sentence += ' ' + goalLevelSentence;
    } else {
        sentence += ' with [Goal Level]';
    }
    sentence += ' to complete ';
    if (goal.GOOBJECTIVE) {
        sentence += goal.GOOBJECTIVE;
    } else {
        sentence += '[Objective]';
    }
    if (goal.GODESC) {
        sentence += ', ' + goal.GODESC;
    }
    if (loa !== '') {
        sentence += ' and requires ' + loa;
    }
    if (goal.GOMINMODMAX) {
        sentence += ' ' + goal.GOMINMODMAX;
    }
    if (goal.GOADL) {
        sentence += ' to ' + goal.GOADL;
    }
    sentence += '.';
    if (goal.GOMGNO === parseInt(store.getState().entities.masterData.PROPS['PTERO_IND_HEP_GOAL_ID'].PRVALUE)) {
        sentence = activityName;
    }
    return sentence;
}

export function getGoalSentenceWC(activityName, goalLevelSentence, goal) {
    let sentence = 'Patient will be able to';

    if (activityName !== '') {
        sentence += ' ' + activityName;
    } else {
        sentence += ' [Activity]'
    }

    if (activityName.startsWith('lift/carry') || activityName.startsWith('push/pull')) {
        sentence += ',';
    } else if (activityName === 'perform essential job demand') {
        sentence += ' of '
        if (goal.GOWORKTASK) {
            sentence += goal.GOWORKTASK;
        } else {
            sentence += '[Work Task]'
        }
        if (goal.GODESC) {
            sentence += ' ' + goal.GODESC;
        }
        if (goalLevelSentence !== '') {
            sentence += ' ' + goalLevelSentence + '.';
        } else {
            sentence += ' [Goal Level].';
        }
    } else {
        if (goalLevelSentence !== '') {
            sentence += ' ' + goalLevelSentence + ',';
        } else {
            sentence += ' [Goal Level],';
        }
    }

    if (activityName !== 'perform essential job demand') {
        if (goal.GODESC) {
            sentence += ' ' + goal.GODESC;
        }
        if (goal.GOWORKTASK) {
            sentence += ' to ' + goal.GOWORKTASK;
        } else {
            sentence += ' to [Work Task]'
        }
        sentence += '.';
    }
    if (goal.GOMGNO === parseInt(store.getState().entities.masterData.PROPS['PTERO_IND_HEP_GOAL_ID'].PRVALUE)) {
        sentence = activityName;
    }
    return sentence;
}

export function getGoalTooltipWC(uid) {
    return (
        <ToolTipBulb uid={uid} position='left' width={300} size='extra-small'>
            <b>Occasional</b><br />
            &nbsp;&nbsp;&nbsp;1 min to 20 min per hour<br />
            &nbsp;&nbsp;&nbsp;1-33% of 8 hour workday<br />
            &nbsp;&nbsp;&nbsp;Less than 100 repetitions/day<br />
            &nbsp;&nbsp;&nbsp;1-12 reps/hour<br />
            <b>Frequent</b><br />
            &nbsp;&nbsp;&nbsp;21 min to 40 min per hour<br />
            &nbsp;&nbsp;&nbsp;34 - 66% of 8 hour workday<br />
            &nbsp;&nbsp;&nbsp;100-500 repetitions/day<br />
            &nbsp;&nbsp;&nbsp;13-62 reps/hour<br />
            <b>Constant</b><br />
            &nbsp;&nbsp;&nbsp;41 min to 60 min per hour<br />
            &nbsp;&nbsp;&nbsp;67 - 100% of 8 hour workday<br />
            &nbsp;&nbsp;&nbsp;greater than 500 repetitions/day<br />
            &nbsp;&nbsp;&nbsp;greater than 62 reps/hour
        </ToolTipBulb >
    );
}


export function getApptStatusIndicator(nsno, asid, date, aptstart) {
    if (nsno === 2) {
        return (<AwardButton size='small' title='Note Complete' />);
    } else if (nsno === 3) {
        return (<SupervisorButton size='small' title='Submitted to Supervising Therapist' icon={faPeopleArrows} />);
    } else if (asid === 1 && new Date().getTime() > new Date(date).getTime() + aptstart) {
        return (<RunningButton size='small' title='Running Late' />);
    } else if (asid === 2) {
        return (<CheckedInButton size='small' title='Checked In' />);
    } else if (asid === 4) {
        return (<CryButton size='small' title='Appointment Cancelled' />);
    } else if (asid === 5) {
        return (<NoShowButton size='small' title='No-Show' />);
    } else if (asid === 6) {
        return (<ApptCompleteButton size='small' title='Appointment Complete' />);
    } else if (asid === 7) {
        return (<RescheduledButton size='small' title='Rescheduled' />);
    } else {
        return (<span />);
    }
}
